import type { TMessages } from '@/types/TMessages'

export const messages = {
  finalPaidAmount: 'Финальная сумма',
  finalPaidVolume: 'Финальный объем',
} satisfies TMessages
